import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { DocumentModel } from '../../../../../models/documents';
import { DateTimeHelper } from '../../../../../utils/DateTimeHelper.util';

@Component
class BlockDocumentItem extends Vue {

  @Prop({ default: () => ({}), type: [Object] })
  source: DocumentModel

  getCreatedDate(createdAt: string) {
    return DateTimeHelper.parseDate(createdAt);
  }

  handleDelete(event) {
    this.$emit('delete', this.source.id)
  }
}

export default BlockDocumentItem;


// WEBPACK FOOTER //
// ./src/containers/block/block-documents/components/block-document-item/index.ts